'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FormattedHTMLMessage',

  mixins: [_utils.I18nCommonMixin],
  propTypes: _utils.commonPropTypes,

  render: function render() {
    var __message = this.props.message;

    var props = (0, _utils.classNameFix)((0, _utils.getPassThroughProps)(this.props));

    // must use dangerouslySetInnerHTML prop to display embedded HTML
    return _react2.default.createElement('i18n-string', _extends({}, props, {
      dangerouslySetInnerHTML: { __html: this._getValue() }
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.433/js/components/FormattedHTMLMessage.js
// module id = 119
// module chunks = 3 4